<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center">
      <b-col md="7" lg="6">
        <b-card >
            <div slot="header">Item Cust. Group - Add/Edit Form </div>
                  <b-input-group >
                        <b-input-group-prepend><label>Item</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.iteminfo"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuItemShow=true" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Customer Group</label></b-input-group-prepend>
                    <b-form-select v-model="frmdata.customer_group" :plain="true" :options="custgroups" ></b-form-select>                   
                  </b-input-group>


            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="close()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>

      </b-col>
    </b-row>
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Item" :centered="true" :lazy="true">
            <lku-item @click="onSelectLkuItem" :formdata="lkuCrewData"></lku-item>
        </b-modal>        
  </div>
</template>

<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import lkuItem from "../lookup/lkuItemLazzy.vue";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuItem},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        itemno:{required},
        customer_group:{required}
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      lkuItemShow: false,
      lkuCrewData: [],
      custgroups:[],
      showList:true,
      showForm:false,
      frmdata:{customer_group:'KONSINYASI' },
      tblData: {
        tablename:'vwitemcustomergroup',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'itemname',
        sortDesc: true
      },
      tblFields:[
          {
            key: "iteminfo",
            label: "Item Info",
            sortable: true
          },
          {
            key: "customer_group",
            // label: "ustomer_group",
            sortable: true
          },
        ],      
      filter:{},
      YesNo :   [{ value: 0, text: 'YES' }, { value: 1, text: 'NO' }],
      user: this.$store.state.user
    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  created: async function() {
    this.tblData.customQuery = this.crudfilter;    
      this.tblFields.push( 
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
      );  
      
      const custGroup = await crud.list({
      tablename:'customergroupmaster',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'group_name',
        sortDesc: true
    }); 
    this.custgroups =custGroup.reduce((arr=[],obj,idx)=>{
        arr.push({ value: obj.group_code, text: obj.group_name });
        return arr;
    },[])
  },  
  methods: {
    onSelectLkuItem: function (lkuData) {
        this.frmdata.iteminfo = lkuData.selected.partnumber.trim() + ' | ' + lkuData.selected.itemname.trim();
        this.frmdata.itemno = lkuData.selected.itemno;
        this.lkuItemShow=false;
    },
    save: async function (callback) {
    this.frmdata.iklan=this.frmdata.iklan || '0';                   
    this.frmdata.koran= this.frmdata.koran || '0';              

        if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              await crud.insert(
                  { tablename:'itemcustomergroup',                      
                     data:{itemno:this.frmdata.itemno,                   
                        customer_group:this.frmdata.customer_group}
                  });
              this.close();                  
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$route.name !==this.$store.state.prevRoute.name)) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
          router.push({name: "bakery.itemcustomergroup"});
      }

    },    
  }
};
</script>
